// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "" + {"375":"eager-p0-core-components","551":"eager-p1-core-slices"}[chunkId] + "." + {"375":"dbb34834cfb5a7fd413d","551":"ca75cf586518b2ba730b"}[chunkId] + ".css";
};